var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimeoutIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "50px",
    viewBox: "0 0 48 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Timeout Icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0.232249785%",
    y1: "0%",
    x2: "99.7677502%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1CB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#004D67",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Session-Timed-Out-Modal",
    transform: "translate(-555.000000, -90.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(525.000000, 60.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Timeout-Icon",
    transform: "translate(30.000000, 30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons/Time-Map-Location/alarm",
    transform: "translate(0.011768, 0.001024)",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M47.5322319,12.3629761 C47.3342319,12.5889761 47.0592319,12.7039761 46.7822319,12.7039761 C46.5492319,12.7039761 46.3162319,12.6229761 46.1272319,12.4569761 L33.9172319,1.74797613 C33.5032319,1.38597613 33.4612319,0.754976128 33.8232319,0.340976128 C34.1852319,-0.0740238719 34.8142319,-0.116023872 35.2282319,0.246976128 L47.4372319,10.9549761 C47.8512319,11.3179761 47.8932319,11.9479761 47.5322319,12.3629761 Z M44.7912319,26.9369761 C44.7912319,38.4899761 35.4142319,47.8889761 23.8892319,47.8889761 C12.3632319,47.8889761 2.98623185,38.4899761 2.98623185,26.9369761 C2.98623185,15.3839761 12.3632319,5.98597613 23.8892319,5.98597613 C35.4142319,5.98597613 44.7912319,15.3839761 44.7912319,26.9369761 Z M23.8892319,7.98197613 C13.4612319,7.98197613 4.97723185,16.4859761 4.97723185,26.9369761 C4.97723185,37.3889761 13.4612319,45.8939761 23.8892319,45.8939761 C34.3172319,45.8939761 42.8012319,37.3889761 42.8012319,26.9369761 C42.8012319,16.4859761 34.3172319,7.98197613 23.8892319,7.98197613 Z M30.5972319,36.0499761 C30.3122319,36.0499761 30.0292319,35.9279761 29.8322319,35.6909761 L23.1252319,27.6429761 C23.0952319,27.6069761 23.0852319,27.5629761 23.0612319,27.5239761 C23.0232319,27.4649761 22.9852319,27.4079761 22.9612319,27.3399761 C22.9372319,27.2739761 22.9302319,27.2079761 22.9212319,27.1399761 C22.9142319,27.0939761 22.8932319,27.0519761 22.8932319,27.0039761 L22.8932319,15.0719761 C22.8932319,14.5199761 23.3392319,14.0739761 23.8892319,14.0739761 C24.4392319,14.0739761 24.8842319,14.5199761 24.8842319,15.0719761 L24.8842319,26.6419761 L31.3602319,34.4119761 C31.7122319,34.8349761 31.6552319,35.4649761 31.2332319,35.8179761 C31.0482319,35.9739761 30.8212319,36.0499761 30.5972319,36.0499761 Z M1.65023185,12.4569761 C1.46223185,12.6229761 1.22823185,12.7039761 0.995231852,12.7039761 C0.718231852,12.7039761 0.443231852,12.5889761 0.246231852,12.3629761 C-0.115768148,11.9479761 -0.0737681482,11.3179761 0.340231852,10.9549761 L12.5502319,0.246976128 C12.9622319,-0.116023872 13.5912319,-0.0740238719 13.9542319,0.340976128 C14.3162319,0.754976128 14.2742319,1.38597613 13.8602319,1.74797613 L1.65023185,12.4569761 Z",
    id: "Shape"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#007EA8",
    opacity: 0.1,
    cx: 26.5,
    cy: 30.5,
    r: 19.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeoutIcon);
export default __webpack_public_path__ + "static/media/timeout-icon.40a539d875f94c0caf0ca6e7b68498bd.svg";
export { ForwardRef as ReactComponent };